export default "__VITE_ASSET__Dm5D306k__"